import { useCallback, useEffect, useState } from 'react';
import useRequest from '../../../../../hooks/useRequest';
import { BotState } from '../../../types';
import StateList from './List';
import axios from 'axios';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const BotStatesForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [botStates, setBotStates] = useState<Array<BotState>>([]);

  const { data: botsData, isValidating } = useRequest(
    ServicePaths.CONTROL.GetBotStates,
  );

  useEffect(() => {
    if (botsData?.length) {
      setBotStates(botsData);
      setIsLoading(false);
    }
  }, [botsData]);

  const handleMove = useCallback((state: BotState) => {
    setBotStates((prev) => {
      const newList = [...(prev ?? [])];

      const index = newList.findIndex((p) => p.botId === state.botId);
      const item = newList[index];

      if (!item) {
        return prev;
      }

      const newItem = {
        ...item,
        isDisabled: true,
        isActive: !item.isActive,
      };

      newList.splice(index, 1, newItem);

      return newList;
    });
  }, []);

  const handleStartAll = useCallback(async () => {
    if (isLoading || isValidating) {
      return;
    }

    setIsLoading(true);

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.StartAllBots,
    });

    setIsLoading(false);

    if (!data?.success) {
      return;
    }

    const newList = botStates.map((b) => ({
      ...b,
      isDisabled: true,
      isActive: true,
    }));

    setBotStates(newList);
  }, [botStates, isLoading, isValidating]);

  const handleStopAll = useCallback(async () => {
    if (isLoading || isValidating) {
      return;
    }

    setIsLoading(true);

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.StopAllBots,
    });

    setIsLoading(false);

    if (!data?.success) {
      return;
    }

    const newList = botStates.map((b) => ({
      ...b,
      isDisabled: true,
      isActive: false,
    }));

    setBotStates(newList);
  }, [botStates, isLoading, isValidating]);

  return (
    <StateList
      data={botStates}
      handleMove={handleMove}
      handleStartAll={handleStartAll}
      handleStopAll={handleStopAll}
      isLoading={isLoading || isValidating}
    />
  );
};

export default BotStatesForm;
